// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3gttB","info":"PatientInfo_info__ojTwf"};